import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { LoginIdCheckHitDTO } from '@/api/DTO/login-account/loginAccount.interface';

interface Props {
	hits: LoginIdCheckHitDTO[];
}

// Sits inside a warning Alert: a light orange header, transparent rows and
// warning-tinted row lines only (no outer frame), like the portal's data grids.
export default function LoginIdHitsTable({ hits }: Props) {
	const { t } = useTranslation();

	return (
		<TableContainer
			sx={(theme) => ({
				'& .MuiTableCell-root': {
					borderColor: alpha(theme.palette.warning.main, 0.3),
				},
			})}
		>
			<Table size='small'>
				<TableHead
					sx={(theme) => ({
						backgroundColor: alpha(theme.palette.warning.main, 0.12),
						'& .MuiTableCell-root': { fontWeight: 500 },
					})}
				>
					<TableRow>
						<TableCell>{t('loginAccount.unit')}</TableCell>
						<TableCell>{t('loginAccount.name')}</TableCell>
						<TableCell>{t('loginAccount.mobilePhone')}</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{hits.map((hit, index) => (
						<TableRow
							key={`${hit.system}-${hit.userId ?? hit.twcMemberId ?? index}`}
						>
							<TableCell>{hit.branchName}</TableCell>
							<TableCell>
								{hit.name || t('loginAccount.unknownHolder')}
							</TableCell>
							<TableCell>{hit.phone || '-'}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}
